/**
 * Motivos de movimiento de caja alineados con chips en `CajaMovimientos`.
 * Unificar texto para poder agrupar en reportes de cierre.
 */
export const MOTIVO_RETIRO_TOPE_EFECTIVO =
  "Retiro por tope de efectivo en caja" as const;

/** Motivo guardado como chip o chip + descripción (— …). */
export function isMotivoRetiroTopeEfectivo(motivo: string): boolean {
  const t = motivo.trim();
  return (
    t === MOTIVO_RETIRO_TOPE_EFECTIVO ||
    t.startsWith(`${MOTIVO_RETIRO_TOPE_EFECTIVO} —`)
  );
}
